import { useState } from "react";
import PropTypes from "prop-types";

import DiffContentToggle from "./DiffContentToggle";
import DifferentiatedRatings from "./DifferentiatedRatings";
import RatingGrid from "../shared/RatingGrid";

import "../../../styles/DifferentiatedRatings.scss";

/**
 * Thin switch: On-level keeps the existing RatingGrid; Differentiated mounts
 * the separate diff tree. Homeroom/Groups pass through ratingGridProps unchanged.
 */
const RatingsContentSwitch = ({ diffProps, ratingGridProps }) => {
    const [contentView, setContentView] = useState("ON_LEVEL");

    return (
        <>
            <DiffContentToggle value={contentView} onChange={setContentView} />
            {contentView === "ON_LEVEL" ? (
                <RatingGrid {...ratingGridProps} />
            ) : (
                <DifferentiatedRatings {...diffProps} />
            )}
        </>
    );
};

RatingsContentSwitch.propTypes = {
    diffProps: PropTypes.object.isRequired,
    ratingGridProps: PropTypes.object.isRequired
};

export default RatingsContentSwitch;
